import {CONSTANTS} from "../constants/constants"
import type {CropperHookReturn, EditorMode} from "../types/types"

interface UseModeSwitchProps {
    cropper: CropperHookReturn
}

export const useModeSwitch = ({cropper}: UseModeSwitchProps) => {
    const handleModeSwitch = (newMode: EditorMode) => {
        if (!cropper) return

        cropper.setMode(newMode)

        if (cropper.imageState.status === "loaded") {
            const newZoom =
                newMode === CONSTANTS.EDITOR_MODES.CROP
                    ? CONSTANTS.ZOOM.DEFAULT
                    : CONSTANTS.TILE_ZOOM.DEFAULT

            cropper.setImageState({
                zoom: newZoom,
            })
        }
    }

    return {handleModeSwitch}
}
